"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";
const ANIMATION_STORAGE_KEY = "isFreeShippingAnimationShown";
const ANIMATION_DURATION_MS = 5000;
export function FreeShippingCelebration() {
  const $ = _c(10);
  const [isAnimationCompleted, setIsAnimationCompleted] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      try {
        if (localStorage.getItem(ANIMATION_STORAGE_KEY) === "true") {
          setIsAnimationCompleted(true);
        }
      } catch {}
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[2] !== isAnimationCompleted) {
    t2 = () => {
      if (isAnimationCompleted) {
        return;
      }
      const timerId = setTimeout(() => {
        setIsAnimationCompleted(true);
        try {
          localStorage.setItem(ANIMATION_STORAGE_KEY, "true");
        } catch {}
      }, ANIMATION_DURATION_MS);
      return () => clearTimeout(timerId);
    };
    t3 = [isAnimationCompleted];
    $[2] = isAnimationCompleted;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  const t4 = isAnimationCompleted ? "bg-[url('/images/confetti-static.svg')]" : "bg-[url('/images/confetti.svg')]";
  let t5;
  if ($[5] !== t4) {
    t5 = cn("relative flex h-[72px] w-full items-center justify-center bg-cover bg-center bg-no-repeat text-base", t4);
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <mark className="bg-white px-2 py-0.5">You’re getting <span className="font-bold">free shipping!</span></mark>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t5) {
    t7 = <div data-testid="free-ship-celebration" className={t5}>{t6}</div>;
    $[8] = t5;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
}